const mark = {
  areas: [
    {
      id: 1,
      slug: 'chest',
      name: '胸マーク'
    },
    {
      id: 2,
      slug: 'back',
      name: '背面'
    },
    {
      id: 3,
      slug: 'sleeve',
      name: '袖マーク'
    }
  ],
  parts: [
    {
      id: 1,
      slug: 'chest_mark',
      name: 'マーク',
      area_id: 1,
    },
    {
      id: 2,
      slug: 'chest_number',
      name: '胸番号',
      area_id: 1,
    },
    {
      id: 3,
      slug: 'back_number',
      name: '背番号',
      area_id: 2,
    },
    {
      id: 4,
      slug: 'back_name',
      name: '背ネーム',
      area_id: 2,
    },
  ],
  elements: [
    {
      id: 1,
      slug: 'both_sides',
      name: '両側',
      area_id: 1,
      part_id: 1,
    },
    {
      id: 2,
      slug: 'one_side',
      name: '片側',
      area_id: 1,
      part_id: 1,
    },
    {
      id: 3,
      slug: 'japanese',
      name: '日本語',
      area_id: 3,
    },
    {
      id: 4,
      slug: 'english',
      name: '英語',
      area_id: 3,
    },
  ],
  items: {
    back_number: [
      {
        id: 0,
        slug: 'back_number_1',
      },
      {
        id: 1,
        slug: 'back_number_2',
      },
      {
        id: 2,
        slug: 'back_number_3',
      },
      {
        id: 3,
        slug: 'back_number_4',
      },
      {
        id: 4,
        slug: 'back_number_5',
      },
      {
        id: 5,
        slug: 'back_number_6',
      },
      {
        id: 6,
        slug: 'back_number_7',
      },
      {
        id: 7,
        slug: 'back_number_8',
      },
      {
        id: 8,
        slug: 'back_number_9',
      },
      {
        id: 9,
        slug: 'back_number_10',
      },
      {
        id: 10,
        slug: 'back_number_11',
      },
      {
        id: 11,
        slug: 'back_number_12',
      },
      {
        id: 12,
        slug: 'back_number_13',
      },
      {
        id: 13,
        slug: 'back_number_14',
      },
      {
        id: 14,
        slug: 'back_number_15',
      },
      {
        id: 15,
        slug: 'back_number_16',
      },
      {
        id: 16,
        slug: 'back_number_17',
      },
      {
        id: 17,
        slug: 'back_number_18',
      },
    ],
    back_name: [
      {
        id: 100,
        slug: 'back_name_1',
      },
      {
        id: 101,
        slug: 'back_name_2',
      },
      {
        id: 102,
        slug: 'back_name_3',
      },
      {
        id: 103,
        slug: 'back_name_4',
      },
      {
        id: 104,
        slug: 'back_name_5',
      },
      {
        id: 105,
        slug: 'back_name_6',
      },
      {
        id: 106,
        slug: 'back_name_7',
      },
      {
        id: 107,
        slug: 'back_name_8',
      },
      {
        id: 108,
        slug: 'back_name_9',
      },
      {
        id: 109,
        slug: 'back_name_10',
      },
      {
        id: 110,
        slug: 'back_name_11',
      },
      {
        id: 111,
        slug: 'back_name_12',
      },
      {
        id: 112,
        slug: 'back_name_13',
      },
      {
        id: 113,
        slug: 'back_name_14',
      },
      {
        id: 114,
        slug: 'back_name_15',
      },
      {
        id: 115,
        slug: 'back_name_16',
      },
      {
        id: 116,
        slug: 'back_name_17',
      },
      {
        id: 117,
        slug: 'back_name_18',
      },
    ],
    japanese: [
      {
        id: 200,
        slug: 'japanese_1',
      },
      {
        id: 201,
        slug: 'japanese_2',
      },
      {
        id: 202,
        slug: 'japanese_3',
      },
      {
        id: 203,
        slug: 'japanese_4',
      },
      {
        id: 204,
        slug: 'japanese_5',
      },
    ],
    english: [
      {
        id: 300,
        slug: 'english_1',
      },
      {
        id: 301,
        slug: 'english_2',
      },
      {
        id: 302,
        slug: 'english_3',
      },
      {
        id: 303,
        slug: 'english_4',
      },
      {
        id: 304,
        slug: 'english_5',
      },
      {
        id: 305,
        slug: 'english_6',
      },
      {
        id: 306,
        slug: 'english_7',
      },
      {
        id: 307,
        slug: 'english_8',
      },
      {
        id: 308,
        slug: 'english_9',
      },
      {
        id: 309,
        slug: 'english_10',
      },
      {
        id: 310,
        slug: 'english_11',
      },
      {
        id: 311,
        slug: 'english_12',
      },
      {
        id: 312,
        slug: 'english_13',
      },
      {
        id: 313,
        slug: 'english_14',
      },
      {
        id: 314,
        slug: 'english_15',
      },
      {
        id: 315,
        slug: 'english_16',
      },
      {
        id: 316,
        slug: 'english_17',
      },
      {
        id: 317,
        slug: 'english_18',
      },
    ],
    chest_number: [
      {
        id: 400,
        slug: 'chest_number_1',
      },
      {
        id: 401,
        slug: 'chest_number_2',
      },
      {
        id: 402,
        slug: 'chest_number_3',
      },
      {
        id: 403,
        slug: 'chest_number_4',
      },
      {
        id: 404,
        slug: 'chest_number_5',
      },
      {
        id: 405,
        slug: 'chest_number_6',
      },
      {
        id: 406,
        slug: 'chest_number_7',
      },
      {
        id: 407,
        slug: 'chest_number_8',
      },
      {
        id: 408,
        slug: 'chest_number_9',
      },
      {
        id: 409,
        slug: 'chest_number_10',
      },
      {
        id: 410,
        slug: 'chest_number_11',
      },
      {
        id: 411,
        slug: 'chest_number_12',
      },
      {
        id: 412,
        slug: 'chest_number_13',
      },
      {
        id: 413,
        slug: 'chest_number_14',
      },
      {
        id: 414,
        slug: 'chest_number_15',
      },
      {
        id: 415,
        slug: 'chest_number_16',
      },
      {
        id: 416,
        slug: 'chest_number_17',
      },
      {
        id: 417,
        slug: 'chest_number_18',
      },
    ],
    both_sides: [
      {
        id: 500,
        slug: 'both_sides_1',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 501,
        slug: 'both_sides_2',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 502,
        slug: 'both_sides_3',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 503,
        slug: 'both_sides_4',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 504,
        slug: 'both_sides_5',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 505,
        slug: 'both_sides_6',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 506,
        slug: 'both_sides_7',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 507,
        slug: 'both_sides_8',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 508,
        slug: 'both_sides_9',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 509,
        slug: 'both_sides_10',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 510,
        slug: 'both_sides_11',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 511,
        slug: 'both_sides_12',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 512,
        slug: 'both_sides_13',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 513,
        slug: 'both_sides_14',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 514,
        slug: 'both_sides_15',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 515,
        slug: 'both_sides_16',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 516,
        slug: 'both_sides_17',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 517,
        slug: 'both_sides_18',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 518,
        slug: 'both_sides_19',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 519,
        slug: 'both_sides_20',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 520,
        slug: 'both_sides_21',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 521,
        slug: 'both_sides_22',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 522,
        slug: 'both_sides_23',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 523,
        slug: 'both_sides_24',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 524,
        slug: 'both_sides_25',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 525,
        slug: 'both_sides_26',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 526,
        slug: 'both_sides_27',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 527,
        slug: 'both_sides_28',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 528,
        slug: 'both_sides_29',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 529,
        slug: 'both_sides_30',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 530,
        slug: 'both_sides_31',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 531,
        slug: 'both_sides_32',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 532,
        slug: 'both_sides_33',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 533,
        slug: 'both_sides_34',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 534,
        slug: 'both_sides_35',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 535,
        slug: 'both_sides_36',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 536,
        slug: 'both_sides_37',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 537,
        slug: 'both_sides_38',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 538,
        slug: 'both_sides_39',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 539,
        slug: 'both_sides_40',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 540,
        slug: 'both_sides_41',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 541,
        slug: 'both_sides_42',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 542,
        slug: 'both_sides_43',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 543,
        slug: 'both_sides_44',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 544,
        slug: 'both_sides_45',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 545,
        slug: 'both_sides_46',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 546,
        slug: 'both_sides_47',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 547,
        slug: 'both_sides_48',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 548,
        slug: 'both_sides_49',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 549,
        slug: 'both_sides_50',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 550,
        slug: 'both_sides_51',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 551,
        slug: 'both_sides_52',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 552,
        slug: 'both_sides_53',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 553,
        slug: 'both_sides_54',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 554,
        slug: 'both_sides_55',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 555,
        slug: 'both_sides_56',
        color1: true,
        color2: true,
        color3: false,
      },
    ],
    one_side: [
      {
        id: 606,
        slug: 'one_side_1',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 607,
        slug: 'one_side_2',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 608,
        slug: 'one_side_3',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 609,
        slug: 'one_side_4',
        background_color: '#00256A',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 610,
        slug: 'one_side_5',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 611,
        slug: 'one_side_6',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 612,
        slug: 'one_side_7',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 613,
        slug: 'one_side_8',
        background_color: '#00031F',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 614,
        slug: 'one_side_9',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 615,
        slug: 'one_side_10',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 616,
        slug: 'one_side_11',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 617,
        slug: 'one_side_12',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 618,
        slug: 'one_side_13',
        background_color: '#777568',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 619,
        slug: 'one_side_14',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 620,
        slug: 'one_side_15',
        background_color: '#006528',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 621,
        slug: 'one_side_16',
        background_color: '#00256A',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 622,
        slug: 'one_side_17',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 623,
        slug: 'one_side_18',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 624,
        slug: 'one_side_19',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 625,
        slug: 'one_side_20',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 626,
        slug: 'one_side_21',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 627,
        slug: 'one_side_22',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 628,
        slug: 'one_side_23',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 629,
        slug: 'one_side_24',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 630,
        slug: 'one_side_25',
        background_color: '#636360',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 631,
        slug: 'one_side_26',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 632,
        slug: 'one_side_27',
        background_color: '#636360',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 633,
        slug: 'one_side_28',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 634,
        slug: 'one_side_29',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 635,
        slug: 'one_side_30',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 636,
        slug: 'one_side_31',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 637,
        slug: 'one_side_32',
        background_color: '#00031F',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 638,
        slug: 'one_side_33',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 639,
        slug: 'one_side_34',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 640,
        slug: 'one_side_35',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 641,
        slug: 'one_side_36',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 642,
        slug: 'one_side_37',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 643,
        slug: 'one_side_38',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 644,
        slug: 'one_side_39',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 645,
        slug: 'one_side_40',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 646,
        slug: 'one_side_41',
        background_color: '#BF001E',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 647,
        slug: 'one_side_42',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 648,
        slug: 'one_side_43',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 649,
        slug: 'one_side_44',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 650,
        slug: 'one_side_45',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 651,
        slug: 'one_side_46',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 652,
        slug: 'one_side_47',
        background_color: '#00966C',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 653,
        slug: 'one_side_48',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 654,
        slug: 'one_side_49',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 655,
        slug: 'one_side_50',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 656,
        slug: 'one_side_51',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 657,
        slug: 'one_side_52',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 658,
        slug: 'one_side_53',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 659,
        slug: 'one_side_54',
        color1: true,
        color2: false,
        color3: false,
      },
    ]
  }
}
export default mark
